import { cloneDeep } from 'lodash';
import {
  EXPERIMENTAL_DESIGN_CLOSE_ALL_MODALS,
  EXPERIMENTAL_DESIGN_SET_ACTIVE_MODAL
} from './modalActions';
import {
  SET_ACTIVE_PROJECT_EVENTS,
  SET_ACTIVE_PROJECT_SIGNALS,
  SET_ACTIVE_PROJECT_TRANSFORMATIONS,
  SET_ACTIVE_PROJECT_SELECTED_TRANSFORMATIONS,
  SET_ACTIVE_PROJECT_STIMULI
} from './occurrenceActions';
import {
  EXPERIMENTAL_DESIGN_SET_SIGNAL_TYPES,
  EXPERIMENTAL_DESIGN_SET_TRANSFORMATIONS
} from './staticDataActions';

/**
 * Basic closed modal state
 * @type {{signals: {list: boolean, edit: boolean}, events: {list: boolean, edit: boolean}, stimuli: {list: boolean, edit: boolean}, globals: {delete: boolean}, condition: {delete: boolean, stack: boolean}, equipment: boolean}}
 */
const closedModalState = {
  signals: {
    list: false,
    add: false,
    edit: false
  },
  transformations: {
    list: false,
    add: false,
    edit: false
  },
  events: {
    list: false,
    add: false,
    edit: false
  },
  stimuli: {
    list: false,
    add: false,
    edit: false
  },
  globals: {
    delete: false
  },
  condition: {
    delete: false,
    stack: false
  },
  equipment: false
};

const initialState = {
  modals: cloneDeep(closedModalState),
  conditions: [],
  signals: [],
  transformations: [],
  events: [],
  stimuli: [],
  signalTypes: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case EXPERIMENTAL_DESIGN_SET_ACTIVE_MODAL:
      return {
        ...state,
        modals: {
          ...state.modals,
          [action.modalType]: {
            ...closedModalState[action.modalType],
            [action.modalAction]: action.modalValue
          }
        }
      };
    case EXPERIMENTAL_DESIGN_CLOSE_ALL_MODALS:
      return { ...state, modals: cloneDeep(closedModalState) };
    case SET_ACTIVE_PROJECT_SIGNALS:
      return { ...state, signals: action.signals };
    case SET_ACTIVE_PROJECT_EVENTS:
      return { ...state, events: action.events };
    case SET_ACTIVE_PROJECT_TRANSFORMATIONS:
      return { ...state, transformations: action.transformation };
    case SET_ACTIVE_PROJECT_SELECTED_TRANSFORMATIONS: {
      console.log('REDUCER CALLED', action.selectedTransformation);
      console.log('old state', state);
      const o = { ...state, selectedTransformations: action.selectedTransformation };
      console.log('o', o);
      return o;
    }
    case SET_ACTIVE_PROJECT_STIMULI:
      return { ...state, stimuli: action.stimuli };
    case EXPERIMENTAL_DESIGN_SET_SIGNAL_TYPES:
      return { ...state, signalTypes: action.signalTypes };
    case EXPERIMENTAL_DESIGN_SET_TRANSFORMATIONS:
      return { ...state, transformations: action.transformations };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/experimentalDesign/reducer.js